export const device_fields = [
    { key: 'id', label: 'Device ID', sortable: false},
    { key: 'imei', label: 'Serial Number', sortable: false },
    { key: 'device_type_desc', label: 'Device Type', sortable: false },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'customer_account_id', label: 'Cust Acct ID', sortable: true },
    { key: 'install_account_id', label:'Dealer Acct ID', sortable: true },
    { key: 'status', label:'Carrier Status', sortable: false},
    { key: 'modified_date', label:'Last Updated', sortable: true, },
    { key: 'action', sortable: false }
]

export const self_install_device_fields = [
    { key: 'id', label: 'Device ID', sortable: false},
    { key: 'imei', label: 'Serial Number', sortable: false },
    { key: 'device_type_desc', label: 'Device Type', sortable: false },
    { key: 'name', label: 'Name', sortable: true },
]


export const device_fields_installation = [
    { key: 'id', label: 'ID', sortable: true, class:'id-table-col'},
    { key: 'imei', label: 'Serial Number', sortable: true },
    { key: 'device_type_desc', label: 'Device Type', sortable: true },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'customer_account_id', label: 'Cust AcctID', sortable: true },
    { key: 'install_account_id', label:'Dealer AcctID', sortable: true },
    { key: 'status', label:'Carrier Status', sortable: true, class:'status-table-col' },
]


const message_fields = [
    { key: 'imei', label: 'IMEI', sortable: true, class:'id-table-col'},
    { key: 'datetime', label:'Date', sortable: true, class:'status-table-col' },
    { key: 'firmwareVersion', label: 'Firmware', sortable: true, class:'id-table-col'},
    { key: 'hardwareVersion', label: 'Hardware', sortable: true, class:'id-table-col'},
    { key: 'batteryVoltage', label:'Battery Voltage', sortable: true }
]


export const device_msg_fields = [
    ...message_fields,
    { key: 'detail' }
]


export const device_msg_detail_fields = [
    ...message_fields,
    { key: 'deviceUptime', label: 'Device Uptime', sortable: true, class:'id-table-col'},
    { key: 'rssi', label: 'RSSI', sortable: true },
    { key: 'sampleRate', label: 'Sample Rate', sortable: true },
    { key: 'txRate', label: 'Name', sortable: true },
    { key: 'tempMaxMinCurrent', label: 'Temperature', sortable: true },
    { key: 'reportReason', label: 'Report Reason', sortable: true, class:'id-table-col'},
    { key: 'retryCount', label:'Retry Count', sortable: true, class:'status-table-col' },
]
